// ContextProvider.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
export const StateContext = createContext();
export const UseStateContext = () => useContext(StateContext);

const initialState = {
  chat: false,
  cart: false,
  userProfile: false,
  notification: false,
  isLoggedIn: false,  // Initialize isLoggedIn to false
};

export const ContextProvider = ({ children }) => {
  const [screenSize, setScreenSize] = useState(undefined);
  const [currentColor, setCurrentColor] = useState('#03C9D7');
  const [currentMode, setCurrentMode] = useState('Light');
  const [themeSettings, setThemeSettings] = useState(false);
  const [activeMenu, setActiveMenu] = useState(true);
  const [isClicked, setIsClicked] = useState(initialState);
  const [user, setUser] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);

  const setMode = (e) => {
    setCurrentMode(e.target.value);
    localStorage.setItem('themeMode', e.target.value);
  };

  const setColor = (color) => {
    setCurrentColor(color);
    localStorage.setItem('colorMode', color);
  };

  useEffect(() => {
    // console.log('Updated userData:', userData);
  }, [userData]);


  const handleClick = (clicked) => setIsClicked({ ...initialState, [clicked]: true });

  /*const loginUser = async (username, password) => {
    try {
      const response = await axios.post('http://springs.pcworldmw.com:3001/api/users/login', { username, password });
      if (response.data === 0) {
        console.log('User not found');
            setIsLoggedIn(false); 
      } else {
        setUserData(await response);
        console.log(response)
        setIsLoggedIn(true);
      }
    } catch (error) {
      setIsLoggedIn(true);
      console.error('Error during authentication:', error);
    }
  }; */

  return (
    <StateContext.Provider value={{
      //loginUser,
      userData,
      setUserData,
      isLoggedIn,
      setIsLoggedIn,
      currentColor,
      currentMode,
      activeMenu,
      screenSize,
      setScreenSize,
      handleClick,
      isClicked,
      initialState,
      setIsClicked,
      setActiveMenu,
      setCurrentColor,
      setCurrentMode,
      setMode,
      setColor,
      themeSettings,
      setThemeSettings,

    }}>
      {children}
    </StateContext.Provider>
  );
};

// export const UseStateContext = () => useContext(StateContext);
